import {CompanyApi, CompanyAuthApi, Configuration, LandingApi} from "../_api";
import {lazySingleton} from "../_common/common";


export const landingSvc = lazySingleton<LandingApi>(()=>new LandingApi(new Configuration({basePath: window.env.JOBS_API_basePath, credentials:'include'})));

export const authSvc = lazySingleton<CompanyAuthApi>(()=>new CompanyAuthApi(new Configuration({basePath: window.env.JOBS_API_basePath, credentials:'include'})));

// singleton
export default lazySingleton<CompanyApi>(()=>new CompanyApi(new Configuration({basePath: window.env.JOBS_API_basePath, credentials:'include'})));
